if (!customElements.get('searchspring-recommendations')) {
  class SearchspringRecommendations extends HTMLElement {
    constructor() {
      super()
      this.products = []
    }

    connectedCallback() {
      this.setupMetadata()
      this.init()
    }

    setupMetadata() {
      this.settings = JSON.parse(
        this.querySelector('.settings').textContent.trim()
      )
      this.siteId = this.settings.siteId
      this.items = this.settings?.items || ''
      this.recommendation_type = this.settings.recommendation_type
      this.exclusions = this.settings.product_excludes
      this.limit = this.settings.limit || 8
      this.sectionName = this.getAttribute('section-name') || 'api-product-card'
      this.placement = this.settings.placement
      if (this.placement === 'mini-cart') {
        this.productKey = 'cart'
      } else {
        this.productKey = 'products'
      }
    }

    async init() {
      const options = { method: 'GET', headers: { accept: 'application/json' } }
      try {
        let url = new URL(
          `https://${this.siteId}.a.searchspring.io/boost/${this.siteId}/recommend?siteId=${this.siteId}`
        )

        if (this.recommendation_type) {
          url.searchParams.append('tags', this.recommendation_type)
        }

        if (this.items && this.items !== '') {
          url.searchParams.append(this.productKey, this.items)
        }

        if (this.exclusions) {
          console.log('exclusions', this.exclusions)
          url.searchParams.append('blockedItems', this.exclusions)
        }

        const response = await fetch(url.toString(), options)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          typeof data[0] === 'object' &&
          Array.isArray(data[0].results)
        ) {
          this.products = data[0].results
        } else {
          this.products = []
          console.error('Invalid API response structure:', data)
        }
      } catch (err) {
        console.error('Error fetching recommendations:', err)
      }

      if (this.products.length > 0) {
        if (this.products.length > this.limit) {
          this.products = this.products.slice(0, this.limit)
        }

        this.render()
      } else {
        this.style.display = 'none'
      }
    }

    render() {
      const container = this.querySelector('.product-recommendations')

      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )
      container.appendChild(content)
      this.loopProducts()
    }

    loopProducts(count = 0, shown = 0) {
      count = count ? count : this.products.length - 1
      let wrapper = this.querySelector(`.splide__list`)
      if (shown <= count) {
        const productUrl = this.products[shown].mappings?.core?.url
        fetch(`${productUrl}?section_id=${this.sectionName}`).then(
          async (response) => {
            const product = await response.text()
            const fresh = document.createElement('div')
            fresh.innerHTML = product

            const item = document.createElement('li')
            item.classList.add('splide__slide')
            item.innerHTML = fresh.querySelector('[data-api-content]').innerHTML

            const productCard = fresh.querySelector('[data-api-content]')
            if (this.placement === 'mini-cart') {
              const addToCartButton = productCard.querySelector('product-form')
              if (addToCartButton) {
                addToCartButton.remove()
              }
            }

            wrapper.innerHTML += `<li class="splide__slide">${productCard.innerHTML}</li>`

            shown++
            this.loopProducts(count, shown)
            if (shown >= this.settings.slides_num) {
              this.querySelectorAll('.splide__slide--placeholder').forEach(
                (slide) => {
                  slide.remove()
                }
              )
            }
          }
        )
      } else {
        this.querySelector('.js-recommendations-slider').classList.add(
          'is-loaded'
        )
        this.classList.add('is-loaded')
        this.initCarousel()
      }
    }

    initCarousel() {
      this.slider = new Splide(
        this.querySelector('.js-recommendations-slider'),
        {
          gap: 20,
          // arrows: this.settings?.show_arrows || false,
          pagination: this.settings?.show_dots || false,
          mediaQuery: 'min',
          perPage: this.settings?.slides_num_mobile
            ? parseInt(this.settings.slides_num_mobile)
            : 2,
          breakpoints: {
            1024: {
              perPage: this.settings?.slides_num
                ? parseInt(this.settings.slides_num)
                : 2,
            },
          },
        }
      )
      this.slider.mount()
    }
  }

  customElements.define(
    'searchspring-recommendations',
    SearchspringRecommendations
  )
}
